import { render, staticRenderFns } from "./VoteHistoryModal.vue?vue&type=template&id=59a088ea&scoped=true"
import script from "./VoteHistoryModal.vue?vue&type=script&lang=js"
export * from "./VoteHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./VoteHistoryModal.vue?vue&type=style&index=0&id=59a088ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a088ea",
  null
  
)

export default component.exports